import { ButtonSize } from "@amzn/stencil-react-components/button";
import { LinkCard } from "@amzn/stencil-react-components/card";
import { UtilityButton, UtilityButtonVariant } from "@amzn/stencil-react-components/dist/submodules/utility-button";
import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Spinner } from "@amzn/stencil-react-components/spinner";
import { Text } from "@amzn/stencil-react-components/text";
import { IconBin } from "@amzn/stencil-react-icons";
import { ListItem as ListItemModel } from "lib/models/list-models";
import { ItemTaxonomyId } from "lib/taxonomy/item-taxonomy-id";
import React, { FC } from "react";
import { useHistory } from "react-router-dom";

import { useLists } from "./useLists";

interface ListItemProps {
  item: ListItemModel;
}

export const ListItem: FC<ListItemProps> = ({ item }) => {
  const history = useHistory();
  const { removeItemFromList, useCatalogItem } = useLists();
  const { catalogItem, itemLoading } = useCatalogItem(item.taxonomyId);

  if (itemLoading) {
    return (
      <View height="78px" width="100%" display="flex" alignItems="center" justifyContent="center">
        <Spinner />
      </View>
    );
  }

  if (!catalogItem) {
    return (
      <View height="78px" width="100%" display="flex" alignItems="center" justifyContent="center">
        <Text fontSize="T200" color="neutral70">
          Item {item.taxonomyId} not found
        </Text>
      </View>
    );
  }

  return (
    <LinkCard
      onClick={() => history.push(`/items/${ItemTaxonomyId.Parse(catalogItem.item.taxonomyId!).getUrlSuffix()}`)}
    >
      <Row height={"78px"} justifyContent="space-between" width={"100%"} gridGap="S250">
        <View
          display="flex"
          height={"78px"}
          padding={"S100"}
          alignItems="flex-start"
          className="img-square-wrapper"
          style={{ borderRadius: "16px" }}
        >
          <img
            alt={catalogItem.item.name}
            src={catalogItem.item.logoUrl}
            data-testid="catalog-item-url"
            style={{
              borderRadius: "16px",
              width: "70px",
              height: "70px",
              objectFit: "contain",
            }}
          />
        </View>
        <Col>
          <Text fontWeight="bold" fontSize="T200">
            {catalogItem.item.name}
          </Text>
          <Text
            fontSize="T100"
            style={{
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              height: "46px",
            }}
          >
            {catalogItem.item.shortDescription}
          </Text>
        </Col>
        <Col justifyContent="center">
          <UtilityButton
            icon={<IconBin color={"red70"} />}
            variant={UtilityButtonVariant.Tertiary}
            size={ButtonSize.Small}
            isDestructive
            onClick={(e) => {
              e.stopPropagation();
              removeItemFromList(catalogItem.item.taxonomyId);
            }}
          />
        </Col>
      </Row>
    </LinkCard>
  );
};
